import { render, staticRenderFns } from "./PMStructureTasksFormConnections.vue?vue&type=template&id=454bbab0&"
import script from "./PMStructureTasksFormConnections.vue?vue&type=script&lang=ts&"
export * from "./PMStructureTasksFormConnections.vue?vue&type=script&lang=ts&"
import style0 from "./PMStructureTasksFormConnections.vue?vue&type=style&index=0&id=454bbab0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports